import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Divider,
  Stack,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getJobs } from "../../services/jobService";
import PageContainer from "./PageContainer";

export default function JobsPage() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = React.useState(null);

  useEffect(() => {
    setError(null);
    const fetchJobs = async () => {
      try {
        const response = await getJobs();
        if (response.success) {
          setJobs(response.message); // since jobs are inside "message"
        }
      } catch (err) {
        setError(err);
        console.error("Error fetching jobs:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  if (loading) {
    return (
      <PageContainer title={'Applications'}>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
          <CircularProgress />
        </Box>
      </PageContainer>
    );
  }

  if (jobs.length === 0) {
    return (
      <Box textAlign="center" mt={4}>
        <Typography variant="h6" color="text.secondary">
          No jobs found.
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <PageContainer title={'Applications'}>
        <Alert severity="error">{error.message}</Alert>
      </PageContainer>
    );
  }

  return (
    <PageContainer
          title={"Applications"}
          breadcrumbs={[{ title: 'Applications'}]}
        >
      <Stack spacing={2}>
        {jobs.map((job) => (
          <Card
            key={job.id}
            sx={{
              borderRadius: 1,
              boxShadow: 2,
              cursor: "pointer",
              transition: "0.2s",
              "&:hover": { boxShadow: 4, transform: "scale(1.01)" },
            }}
            onClick={() => navigate(`/app/hr/applications/job/${job.id}/applications`)}
          >
            <CardContent>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="h6" fontWeight="bold">
                  {job.jobTitle}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {new Date(job.createdAt).toLocaleDateString()}
                </Typography>
              </Box>

              <Typography variant="subtitle2" color="text.secondary">
                {job.department} • {job.location}
              </Typography>

              <Typography variant="body2" mt={1}>
                <b>Type:</b> {job.employmentType} | <b>Experience:</b>{" "}
                {job.experienceLevel}
              </Typography>

              <Divider sx={{ my: 1.5 }} />

              <Typography variant="body2" color="text.secondary" noWrap>
                {job.jobSummary}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </PageContainer>
  );
}
